import { BaseProcessor, ColumnMetaData } from './BaseProcessor';
import * as Highcharts from 'highcharts';

export class PieChart extends BaseProcessor {
  protected override chartType: string = 'pie';

  constructor(
    data: { [key: string]: any }[],
    xAxis: string[],
    yAxis: string[],
    columnsMetaData: { [key: string]: ColumnMetaData } = {},
    options: any = {}
  ) {
    super();
    this.data = data;
    this.xAxis = xAxis;
    this.yAxis = yAxis;
    this.columnsMetaData = columnsMetaData;
    this.options = options;
    this.addChartTypeToOptions();
  }

  addTooltip() {
    this.options.tooltip = {
      headerFormat: '',
      pointFormatter: function () {
        let yMetaData = this.series.userOptions.yMetaData;
        let xMetaData = this.series.userOptions.xMetaData;
        let tooltipString = '';
        if (yMetaData.type === 'datetime' || yMetaData.type === 'date') {
          const formattedDate = Highcharts.dateFormat('%Y-%m-%d', this.y);
          tooltipString = `<b>${formattedDate}</b><br/>`;
        } else if (yMetaData.type === 'month') {
          const formattedDate = Highcharts.dateFormat('%b %Y', this.y);
          tooltipString = `<b>${formattedDate}</b><br/>`;
        } else if (yMetaData.type === 'year') {
          const formattedDate = Highcharts.dateFormat('%Y', this.y);
          tooltipString = `<b>${formattedDate}</b><br/>`;
        } else {
          tooltipString =
            typeof this.y === 'number'
              ? this.y.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : this.y;
        }

        let xTooltipString = '';
        const xData = this.series.data[this.x].name;
        if (xMetaData.type === 'datetime' || xMetaData.type === 'date') {
          const formattedDate = Highcharts.dateFormat('%Y-%m-%d', xData);
          xTooltipString = `<b>${formattedDate}</b><br/>`;
        } else if (xMetaData.type === 'month') {
          const formattedDate = Highcharts.dateFormat('%b %Y', xData);
          xTooltipString = `<b>${formattedDate}</b><br/>`;
        } else if (xMetaData.type === 'year') {
          const formattedDate = Highcharts.dateFormat('%Y', xData);
          xTooltipString = `<b>${formattedDate}</b><br/>`;
        } else {
          xTooltipString =
            typeof xData === 'number'
              ? this.y.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : xData;
        }
        return `<span style='font-size:0.6rem'>${
          xMetaData?.unit || ''
        }${xTooltipString}</span><br><span style="color:${
          this.color
        }">\u25CF</span> ${this.series.name}: <b> ${
          yMetaData?.unit || ''
        }${tooltipString}</b><br/>`;
      },
    };
  }

  protected preprocessData() {
    delete this.options.series;
    delete this.options.data;

    let xAxisCols = this.xAxis[0];
    let yAxisCols = this.yAxis[0];

    this.options.series = [
      {
        name: yAxisCols,
        xMetaData: this.columnsMetaData[xAxisCols],
        yMetaData: this.columnsMetaData[yAxisCols],
        data: this.data.map((values: any) => {
          return [
            this.formateValueWithType(
              values[xAxisCols],
              this.columnsMetaData[xAxisCols]
            ).toString() + '\u200B', // zero-width space
            this.formateValueWithType(
              values[yAxisCols],
              this.columnsMetaData[yAxisCols]
            ),
          ];
        }),
      },
    ];

    this.addTooltip();
  }
}
